import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AddAEditSalesPage from "src/pages/add-sales";
import ForgotPasswordPage from "src/pages/auth/forgot-password";
import DashboardPage from "src/pages/dashboard";
import AggregatorsPage from "src/pages/aggregators";
import LoginPage from "src/pages/auth/login";
import SingUpPage from "src/pages/auth/sing-up";
import { PublicRoutes } from "./public-routes";
import { PrivateRoutes } from "./private-routes";
import ResetPasswordPage from "src/pages/auth/reset-password";
import { Layout } from "src/shared/layout";
import AddEditAggregator from "src/pages/aggregators/tabs/aggregators-list/add-new-aggregator";
import AddEditAggregatorFees from "src/pages/aggregators/tabs/aggregator-fees/add-edit-aggregator-fees";
import Settings from "src/pages/settings";
import AddEditRole from "src/pages/settings/tabs/roles/add-edit-role";
import OperationCost from "src/pages/operation-cost";
import SalaryModule from "src/pages/salary";
import EmployeesTab from "src/pages/salary/tabs/employees";
import EmployeeFormPage from "src/pages/salary/tabs/employees/employee-form";
import SalariesTab from "src/pages/salary/tabs/salaries";
import TransactionDetails from "src/pages/operation-cost/tabs/transaction-list/transaction-details";
import MyProfile from "src/pages/my- profile";
import HomePage from "src/pages/home-page";
import PricesPage from "src/pages/prices-page";
import ReportsPages from "src/pages/reports";
import ItemDetailReportPage from "src/pages/reports/item-detail";
import TopItemsFluctuationsPage from "src/pages/reports/top-items-fluctuations";
import TaxReportPage from "src/pages/reports/tax";
import OperationExpensesReportPage from "src/pages/reports/operation-expenses";
import AggregatorsPlReportPage from "src/pages/reports/aggregators-pl";
import AggregatorStatementReportPage from "src/pages/reports/aggregator-statement";
import PaymentMovementReportPage from "src/pages/reports/payment-movement";
import ItemMovementReportPage from "src/pages/reports/item-movement";
import PurchasingTransactionDetails from "src/pages/purchasing/tabs/purchasing/transaction-details";
import Purchasing from "src/pages/purchasing";
import ImportPurchasing from "src/pages/purchasing/tabs/purchasing/import-purchasing";
import ContactUs from "src/pages/contact";
import WorkWithUs from "src/pages/work-with-us";
import AggregatorsCalculator from "src/pages/aggregators-calculator";
import Inventory from "src/pages/inventory";
import AddNewStocktaking from "src/pages/inventory/tabs/count/all/add-new-stocktaking";
import AddNewCogs from "src/pages/inventory/tabs/cogs/cogs-formula/add-new-cogs";
import Matching from "src/pages/matching";
import Orders from "src/pages/matching/tabs/aggregator/orders";
import AddAggregatorTransactions from "src/pages/matching/tabs/aggregator/Add-aggregator-transactions";
import Auditing from "src/pages/auditing";
import TransferTransactionDetails from "src/pages/inventory/tabs/transfer/transaction-details";
import AddAdjustments from "src/pages/inventory/tabs/items/tabs/adjustments/add-adjustments";
import NoAccessPage from "src/pages/no-access";
import {
  AggregatorsPermissions,
  GeneralPermissions,
  SalesPermissions,
  SettingsPermissions,
} from "src/constants/permissions";
import UserLogs from "src/pages/settings/tabs/users/user-logs";
import ProductionRecipe from "src/pages/inventory/tabs/production/tabs/all/proudction-recipe";
import ProductionEntryDetails from "src/pages/inventory/tabs/production/tabs/entries/entry-details";
import PoRequestDetails from "src/pages/inventory/tabs/re-order/tabs/po/po-details";
import Menu from "src/pages/menu";
import ProductRecipe from "src/pages/menu/tabs/all/product-recipe";
import ModifierRecipe from "src/pages/menu/tabs/modifiers/modifier-recipe";
import Sales from "src/pages/sales";
import ProductSalesDetails from "src/pages/sales/tabs/product-sales/product-sales-details";
import RecipeCostSalesDetails from "src/pages/inventory/tabs/cogs/recipe-cost/details";
import AddBankMatchingTransactions from "src/pages/matching/tabs/bank/add-bank-transactions";
import BankMatchingTrans from "src/pages/matching/tabs/bank/orders";
import AddEditInvoice from "src/pages/sales/tabs/sales-invoices/add-invoice";
import Events from "src/pages/events";
import FixedAssets from "src/pages/fixed-assets";
import Integrations from "src/pages/integrations";
import RetmSettings from "src/pages/integrations/retm";
import RetmCallback from "src/pages/integrations/retm/callback";
import RetmJourneyImport from "src/pages/integrations/retm/tabs/journey";
import RetmMappings from "src/pages/integrations/retm/tabs/mappings";
import RetmMenuImport from "src/pages/integrations/retm/tabs/menu-import";
import FoodicsSettings from "src/pages/integrations/foodics";
import FoodicsCallback from "src/pages/integrations/foodics/callback";
import FoodicsOrders from "src/pages/integrations/foodics/tabs/orders";
import FoodicsMappings from "src/pages/integrations/foodics/tabs/mappings";
import FoodicsMenuPage from "src/pages/integrations/foodics/tabs/menu";
import FoodicsInventoryPage from "src/pages/integrations/foodics/tabs/inventory";
import AccountTree from "src/pages/account-tree";
import AccountStatementReportPage from "src/pages/reports/account-statement";
import SupplierStatementReportPage from "src/pages/reports/supplier-statement";
import VendorStatementReportPage from "src/pages/reports/vendor-statement";
import ExpensesStatementReportPage from "src/pages/reports/expenses-statement";
import TrialBalanceReportPage from "src/pages/reports/trial-balance";
import BalanceSheetReportPage from "src/pages/reports/balance-sheet";
import GeneralLedgerReportPage from "src/pages/reports/general-ledger";
import ProfitAndLossReportPage from "src/pages/reports/profit-and-loss";
import { useOneBranchHasPermission } from "src/shared/hooks/has-permission-hook";

function AllRoutes() {
  const hasPermission = useOneBranchHasPermission();
  // permissions
  const viewDashboardPermission = hasPermission(
    GeneralPermissions.viewDashboard,
  );
  const addAggPermission = hasPermission(AggregatorsPermissions.addAgg);
  const addCostAndFeePermission = hasPermission(
    AggregatorsPermissions.addAggCostFee,
  );
  const addRolePermission = hasPermission(SettingsPermissions.addRole);
  const editRolePermission = hasPermission(SettingsPermissions.editRole);
  const editSalesPermission = hasPermission(SalesPermissions.editSale);

  return (
    <BrowserRouter>
      <Routes>
        {/* common: public and private routes */}
        <Route element={<PricesPage />} path="/prices" />
        <Route element={<AggregatorsCalculator />} path="/aggregator-calc" />
        <Route element={<PublicRoutes />}>
          <Route element={<LoginPage />} path="/" />
          <Route element={<LoginPage />} path="/login" />
          <Route element={<SingUpPage />} path="/sign-up" />
          <Route element={<ContactUs />} path="/contact-us" />
          <Route element={<WorkWithUs />} path="/work-with-us" />

          <Route element={<ForgotPasswordPage />} path="/forgot-password" />
          <Route element={<ResetPasswordPage />} path="/reset-password/:id" />
        </Route>
        <Route element={<PrivateRoutes />}>
          {/* Add sales  */}
          <Route element={<AddAEditSalesPage />} path="/" />
          <Route
            element={true ? <AddAEditSalesPage /> : <NoAccessPage />}
            path="/add-sales"
          />
          <Route
            element={
              editSalesPermission ? <AddAEditSalesPage /> : <NoAccessPage />
            }
            path="/sales/:id/edit"
          />

          {/* My Profile */}
          <Route element={<MyProfile />} path="/profile" />
          <Route element={<Layout />}>
            {/* Sales */}
            <Route element={<Sales />} path="/sales" />
            <Route element={<Sales />} path="/sales/list" />
            <Route element={<Sales />} path="/sales/products" />
            <Route
              element={<ProductSalesDetails />}
              path="/sales/products/:id"
            />
            <Route element={<Sales />} path="/sales/modifiers" />
            <Route
              element={<ProductSalesDetails />}
              path="/sales/modifiers/:id"
            />
            <Route element={<Sales />} path="/sales/clients" />
            <Route element={<Sales />} path="/sales/invoices" />
            <Route
              element={<AddEditInvoice />}
              path="/sales/invoices/add-invoice"
            />
            <Route
              element={<AddEditInvoice />}
              path="/sales/invoices/add-credit-note"
            />
            <Route element={<AddEditInvoice />} path="/sales/invoices/:id" />
            <Route element={<AddEditInvoice />} path="/sales/invoices/:id/copy" />
            {/* Dashboard */}
            <Route
              element={
                viewDashboardPermission ? <DashboardPage /> : <NoAccessPage />
              }
              path="/dashboard"
            />
            {/* Aggregators */}
            {/* Aggregators */}
            <Route element={<AggregatorsPage />} path="/aggregators" />
            <Route element={<AggregatorsPage />} path="/aggregators/summary" />
            <Route element={<AggregatorsPage />} path="/aggregators/list" />
            <Route
              element={<AggregatorsPage />}
              path="/aggregators/transactions"
            />
            <Route element={<AggregatorsPage />} path="/aggregators/fees" />
            <Route
              element={
                addAggPermission ? <AddEditAggregator /> : <NoAccessPage />
              }
              path="/aggregators/add-agg"
            />
            <Route
              element={<AddEditAggregator />}
              path="/aggregators/edit-agg/:id"
            />
            <Route
              element={
                addCostAndFeePermission ? (
                  <AddEditAggregatorFees />
                ) : (
                  <NoAccessPage />
                )
              }
              path="/aggregators/add-agg-fees"
            />
            <Route
              element={<AddEditAggregatorFees />}
              path="/aggregators/edit-agg-fees/:id"
            />
            {/* Third Eye Report */}
            <Route element={<ReportsPages />} path="/reports" />
            <Route
              element={<TopItemsFluctuationsPage />}
              path="/reports/top-items-fluctuations"
            />
            <Route
              element={<ItemDetailReportPage />}
              path="/reports/item-detail"
            />
            <Route element={<TaxReportPage />} path="/reports/tax" />
            <Route
              element={<AccountStatementReportPage />}
              path="/reports/account-statement"
            />
            <Route
              element={<SupplierStatementReportPage />}
              path="/reports/supplier-statement"
            />
            <Route
              element={<VendorStatementReportPage />}
              path="/reports/vendor-statement"
            />
            <Route
              element={<ExpensesStatementReportPage />}
              path="/reports/expenses-statement"
            />
            <Route
              element={<OperationExpensesReportPage />}
              path="/reports/operation-expenses"
            />
            <Route
              element={<AggregatorsPlReportPage />}
              path="/reports/aggregators-pl"
            />
            <Route
              element={<AggregatorStatementReportPage />}
              path="/reports/aggregator-statement"
            />
            <Route
              element={<PaymentMovementReportPage />}
              path="/reports/payment-movement"
            />
            <Route
              element={<ItemMovementReportPage />}
              path="/reports/item-movement"
            />
            <Route
              element={<TrialBalanceReportPage />}
              path="/reports/trial-balance"
            />
            <Route
              element={<ProfitAndLossReportPage />}
              path="/reports/profit-and-loss"
            />
            <Route
              element={<BalanceSheetReportPage />}
              path="/reports/balance-sheet"
            />
            <Route
              element={<GeneralLedgerReportPage />}
              path="/reports/general-ledger"
            />
            {/* Operation Cost */}
            <Route element={<OperationCost />} path="/operation" />
            <Route path="/operation/summary" element={<OperationCost />} />
            <Route path="/operation/vendors" element={<OperationCost />} />
            <Route path="/operation/accounts" element={<OperationCost />} />
            <Route
              path="/operation/expenses-bills"
              element={<OperationCost />}
            />
            <Route path="/operation/cost-list" element={<OperationCost />} />
            <Route
              element={<TransactionDetails />}
              path="/operation/transaction/:id"
            />
            {/* Salary */}
            <Route path="/salary" element={<SalaryModule />}>
              <Route index element={<Navigate to="employees" replace />} />
              <Route path="employees/new" element={<EmployeeFormPage />} />
              <Route path="employees/:id" element={<EmployeeFormPage />} />
              <Route path="employees/:id/edit" element={<EmployeeFormPage />} />
              <Route path="employees" element={<EmployeesTab />} />
              <Route path="salaries" element={<SalariesTab />} />
            </Route>
            {/* Fixed Assets */}
            <Route element={<FixedAssets />} path="/assets" />
            <Route path="/assets/summary" element={<FixedAssets />} />
            <Route path="/assets/category" element={<FixedAssets />} />
            <Route path="/assets/list" element={<FixedAssets />} />
            <Route path="/assets/cost-list" element={<FixedAssets />} />
            <Route
              path="/assets/cost-list/:id"
              element={<TransactionDetails />}
            />
            <Route
              element={<TransactionDetails />}
              path="/assets/transaction/:id"
            />
            {/* Settings */}
            <Route element={<Settings />} path="/settings" />
            <Route element={<Settings />} path="/settings/branches" />
            <Route element={<Settings />} path="/settings/users" />
            <Route element={<Settings />} path="/settings/roles" />
            <Route element={<Settings />} path="/settings/payments" />
            <Route
              element={<Settings />}
              path="/settings/payment-transactions"
            />
            <Route element={<Settings />} path="/settings/capital" />
            <Route
              element={addRolePermission ? <AddEditRole /> : <NoAccessPage />}
              path="/settings/roles/add-new-role"
            />
            <Route
              element={editRolePermission ? <AddEditRole /> : <NoAccessPage />}
              path="/settings/roles/:id/edit"
            />
            <Route element={<UserLogs />} path="/settings/users/:id/logs" />
            {/* purchasing */}
            <Route element={<Purchasing />} path="/purchasing" />
            <Route element={<Purchasing />} path="/purchasing/summary" />
            <Route element={<Purchasing />} path="/purchasing/list" />
            <Route element={<Purchasing />} path="/purchasing/suppliers" />
            <Route
              element={<PurchasingTransactionDetails />}
              path="/purchasing/:id"
            />
            <Route element={<ImportPurchasing />} path="/purchasing/import" />
            {/* Events */}
            <Route element={<Events />} path="/events" />
            <Route element={<Events />} path="/events/list" />
            {/* Inventory */}
            <Route element={<Inventory />} path="/inventory" />
            <Route element={<Inventory />} path="/inventory/summary" />
            <Route element={<Inventory />} path="/inventory/items" />
            <Route element={<Inventory />} path="/inventory/counts" />
            <Route element={<Inventory />} path="/inventory/level" />
            <Route element={<Inventory />} path="/inventory/cogs" />
            <Route element={<Inventory />} path="/inventory/production" />
            <Route element={<Inventory />} path="/inventory/reorder" />
            <Route
              element={<AddNewStocktaking />}
              path="/:brId/:brName/add-stocktaking"
            />
            <Route element={<AddNewStocktaking />} path="/counts/:id/edit" />
            <Route
              element={<AddNewCogs />}
              path="/inventory/cogs/add-new-cogs"
            />
            <Route element={<AddNewCogs />} path="/inventory/cogs/:id/edit" />
            <Route
              element={<RecipeCostSalesDetails />}
              path="/inventory/cogs/recipe/:id"
            />
            <Route element={<Inventory />} path="/inventory/transfer" />
            <Route
              element={<TransferTransactionDetails />}
              path="/transfer/transaction/:id"
            />
            <Route
              element={<AddAdjustments />}
              path="/inventory/add-adjustments"
            />
            <Route element={<AddAdjustments />} path="/adjustments/:id/view" />
            <Route
              element={<ProductionRecipe />}
              path="/inventory/production/:proId/recipe"
            />
            <Route
              element={<ProductionRecipe />}
              path="/inventory/production/:proId/recipe/:recipeId"
            />
            <Route
              element={<ProductionEntryDetails />}
              path="/inventory/production/:entryId"
            />
            {/* reorder */}
            <Route
              element={<PoRequestDetails />}
              path="/inventory/reorder/po/:id"
            />
            {/* Menu */}
            <Route element={<Menu />} path="/menu" />
            <Route element={<Menu />} path="/menu/products" />
            <Route element={<Menu />} path="/menu/categories" />
            <Route element={<Menu />} path="/menu/modifiers" />
            <Route element={<Menu />} path="/menu/deleted" />
            {/* Menu products */}
            <Route
              element={<ProductRecipe />}
              path="/menu/products/:productId/recipe"
            />
            <Route
              element={<ProductRecipe />}
              path="/menu/products/:productId/recipe/:recipeId"
            />
            {/* Menu modifiers */}
            <Route
              element={<ModifierRecipe />}
              path="/menu/modifiers/:modifierId/recipe"
            />
            <Route
              element={<ModifierRecipe />}
              path="/menu/modifiers/:modifierId/recipe/:recipeId"
            />
            {/* Matching */}
            <Route element={<Matching />} path="/matching" />
            {/* <Route element={<Matching />} path="/matching/link-list" /> */}
            <Route element={<Matching />} path="/matching/bank" />
            <Route element={<Matching />} path="/matching/aggregator" />
            <Route element={<Orders />} path="/matching/aggregator/:id" />
            <Route
              element={<AddAggregatorTransactions />}
              path="/matching/add-aggregator-transactions"
            />
            <Route element={<BankMatchingTrans />} path="/matching/bank/:id" />
            <Route
              element={<AddBankMatchingTransactions />}
              path="/matching/bank/add-bank-transactions"
            />
            {/* Auditing */}
            <Route element={<Auditing />} path="/auditing" />
            {/* Integrations */}
            <Route element={<Integrations />} path="/integrations" />
            <Route element={<RetmSettings />} path="/integrations/retm" />
            <Route element={<RetmCallback />} path="/integrations/retm/callback" />
            <Route
              element={<Navigate to="/integrations/retm/journey" replace />}
              path="/integrations/retm/orders"
            />
            <Route element={<RetmJourneyImport />} path="/integrations/retm/journey" />
            <Route element={<RetmMappings />} path="/integrations/retm/mappings" />
            <Route element={<RetmMenuImport />} path="/integrations/retm/menu-import" />
            {/* Foodics Integration */}
            <Route element={<FoodicsSettings />} path="/integrations/foodics" />
            <Route element={<FoodicsCallback />} path="/integrations/foodics/callback" />
            <Route element={<FoodicsOrders />} path="/integrations/foodics/orders" />
            <Route element={<FoodicsMappings />} path="/integrations/foodics/mappings" />
            <Route element={<FoodicsMenuPage />} path="/integrations/foodics/menu" />
            <Route element={<FoodicsInventoryPage />} path="/integrations/foodics/inventory" />
             {/* account tree */}
            <Route element={<AccountTree />} path="/for-accountant" />
            <Route element={<AccountTree />} path="/for-accountant/tree" />
            <Route
              element={<AccountTree />}
              path="/for-accountant/manual-journals"
            />
            <Route element={<AccountTree />} path="/for-accountant/ledger" />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AllRoutes;
